import angular from 'angular';
import _ from 'lodash-es';
import controller from './email.controller';
import template from '../textfield/textfield.html';
import EmailComponent from './email.component';

const emailConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	const views = _.cloneDeep(KformComponentsProvider.$get().components.textfield.views);
	// _.each(views, view => {
	// 	if (view.name === 'Validation') {
	// 		view.template = 'kform/components/email/validate.html';
	// 	}
	// });

	KformComponentsProvider.register('email', {
		title: 'Email',
		template,
		group: 'advanced',
		children:   false,
		selectable: true,
		settings: new EmailComponent(),
		icon: 'fa fa-at',
		views,
		controller,
	});
};

export default angular.module('app').config(emailConfig);
